import { useCallback, useRef } from 'react';
import { useSignalRListener } from './useSignalR';
import { useMissedEventBeat } from './useMissedEventBeat';
import { invalidatePeriodStatusQueries, PERIOD_EVENTS } from './useWorkflowChromeStatusSync';

/**
 * Refresh a period's status reads when a live event says it moved, with the missed-event beat
 * under it. For code outside the workflow chrome, where `useWorkflowChromeStatusSync` is not
 * listening; inside it the two land on the same queries and React Query fetches each once.
 */
export function usePeriodLiveRefresh(periodId: string | undefined): void {
  const periodIdRef = useRef(periodId);
  periodIdRef.current = periodId;

  const refresh = useCallback(() => {
    invalidatePeriodStatusQueries(periodIdRef.current);
  }, []);
  const onEvent = useCallback(
    (payload?: { period_id?: string }) => {
      // An event naming another period is not this one's; one naming none may be.
      if (payload?.period_id && payload.period_id !== periodIdRef.current) return;
      refresh();
    },
    [refresh]
  );
  // PERIOD_EVENTS is a module constant, so the listeners are the same on every render.
  for (const event of PERIOD_EVENTS) useSignalRListener(event, onEvent);

  useMissedEventBeat(refresh, !!periodId);
}
